RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    const CompanyPie = App.widgets.Chart.extend({
        className: 'chart block-chart',
        template: '#widgetCompanyPieChartTemplate',

        tooltipTemplate: '#pieChartTooltip',

        legendItemTemplate: '#companyPieChartLegendItemTemplate',

        ui: {
            noDataMsg: '.x-no-data-msg',
            mainContent: '.x-content',
            legend: '.company-pie-chart-legend'
        },

        // NOTE a donut with no hole is a pie :)
        chartType: RivalIQ.graph.Donut.extend({
            donutRatio: 0
        }),

        loadData: function () {
            const me = this;
            const metrics = me.dashboardModel.metrics;
            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            return collection.fetch().done(function (metrics) {
                me.metric = metrics.first();
            });
        },

        onAttachLoaded: function () {
            const me = this;
            me.data = me.metric.getValue({
                format: false
            });

            if (_.every(me.data, function (d) { return d[1] <= 0; })) {
                // data is all zeros and/or nulls
                me.ui.noDataMsg.removeClass('hide');
                me.ui.mainContent.addClass('hide');

                if (me.dashboardModel.getWidgetInstanceState) {
                    const widgetInstanceState = me.dashboardModel.getWidgetInstanceState();
                    const metricSource = me.metric.get('source');

                    if (RivalIQ.enums.sourceDetails[metricSource].privateData &&
                        widgetInstanceState && _.get(widgetInstanceState, ['sources', metricSource]) &&
                        _.isEmpty(_.get(widgetInstanceState, ['companies']))) {
                        const View = RivalIQ.apps.Insights.views.getNoPresenceView(metricSource);
                        const view = new View({
                            dashboardModel: me.dashboardModel,
                            el: me.ui.noDataMsg.parent()
                        });
                        view.render();
                    }
                }

            } else {
                me.ui.noDataMsg.addClass('hide');
                me.ui.mainContent.removeClass('hide');

                App.widgets.Chart.prototype.onAttachLoaded.call(me);
                me.showLegend();
            }
        },

        _getLegendPopoverRow: function (d) {
            const me = this;

            if (!me.metric.get('companyId')) {
                const companyId = _.head(d);
                const calculationMetadata = me.metric.getCalculationMetadata(companyId);
                if (!_.isEmpty(_.get(calculationMetadata, ['missingSources'])) && !_.get(calculationMetadata, ['missingAllSources'])) {
                    // Show a warning if we're missing some, but not all, sources.
                    return RivalIQ.utils.incompleteData.getIncompleteDataPopover('companyId', companyId, me.metric, calculationMetadata);
                }
            }
        },

        showLegend: function () {
            const me = this;
            const focusCompanyId = me.getProp('focusCompanyId');

            const html = _.map(me.legendData, function (d, i) {
                const className = me.metric.getClassName(d);
                const color = me.colorFun(d, i);
                const name = me.getDimensionName(d);
                const abbreviatedValue = me.metric.format(d);
                const tooltip = me.getTooltip(d, color);

                const partialDataPopover = me._getLegendPopoverRow(d);

                return Marionette.TemplateCache.get(me.legendItemTemplate)({
                    tooltip: tooltip,
                    className: className, // NOTE if truthy, determines color
                    color: color,
                    name: name,
                    isFocusCompany: (d[0] === focusCompanyId),
                    value: abbreviatedValue,
                    partialDataPopover: partialDataPopover || null
                });
            }).join('');

            me.ui.legend.html(html);
            me.initializePopovers();
        },

        initializePopovers: function () {
            const me = this;
            me.$('[data-toggle="popover"]').popover({
                html: true,
                trigger: 'hover',
                placement: 'auto top',
                container: 'body'
            });
        },

        getDimensionName: function (d) {
            const me = this;
            const id = _.head(d);

            // special case for 'Others'
            if (id === me.chartType.prototype.remainderSliceLabel) {
                return id;
            }

            const dimension = _.head(RivalIQ.metric.getFreeDimensions(me.metric.attributes));
            const name = RivalIQ.metric.search.getDimensionValue(me.metric.attributes, 'format', dimension, id);

            if (_.isFunction(name)) {
                return name(id);
            }

            return name;
        },

        getTooltip: function (d, color) {
            const me = this;
            const className = me.metric.getClassName(d);
            const value = d[1];

            return Marionette.TemplateCache.get(me.tooltipTemplate)({
                className: className, // NOTE if truthy, determines color
                color: color,
                name: me.getDimensionName(d),
                value: me.metric.formatExpanded(d),
                percentage: RivalIQ.formatter.formats.percentAbsolute(value / me.pieSum)
            });
        },

        getColors: function (data) {
            const me = this;
            const focusCompanyId = me.getProp('focusCompanyId');
            const color = d3.scale
                .category20()
                .domain(d3.range(_.size(data)));

            return function (d, i) {
                const companyId = d[0];

                if (companyId === focusCompanyId) {
                    return RivalIQ.enums.colors.focus;
                }

                return color(i);
            };
        },

        getChartAttributes: function () {
            const me = this;
            const limit = me.getProp('limit');

            // negative values shouldn't be here... but we DO want to keep zeros
            // and nulls
            me.data = _.reject(me.data, function (d) {
                return d[1] < 0;
            });

            // sort biggest to smallest, with nulls at the end
            me.data.sort(function (a, b) {
                if (_.isNull(b[1])) {
                    return -1;
                }
                if (_.isNull(a[1])) {
                    return 1;
                }
                return b[1] - a[1];
            });

            // legend shows zeros/nulls
            if (_.size(me.data) > limit) {
                // NOTE similar to the remainder logic in the Donut graph, but
                // here we add the 'Others' slice even if it's zero
                me.legendData = me.data.slice(0, limit);

                // if the remaining slices are all nulls, then set their sum to
                // be null; otherwise, sum the remaining slices
                const othersSum = (_.isNull(_.last(me.data[limit])) ? null : _.sumBy(me.data.slice(limit), _.last));

                me.legendData.push([
                    me.chartType.prototype.remainderSliceLabel,
                    othersSum
                ]);
            } else {
                me.legendData = me.data;
            }

            // don't pass zeros/nulls into the pie, otherwise the slices and
            // tooltips may get weird
            me.pieData = _.reject(me.data, function (d) {
                return d[1] <= 0;
            });

            me.pieSum = _.reduce(me.pieData, function (acc, d) {
                return acc + d[1];
            }, 0);

            me.colorFun = me.getColors(me.legendData);

            return {
                data: me.pieData,
                limit: limit,
                shouldAddRemainder: true,
                colorFun: me.colorFun,
                height: me.getProp('height'),
                width: me.getProp('width'),
                graphOptions: {
                    tooltipContent: function (slice, color) {
                        return me.getTooltip(slice.data, color);
                    }
                }
            };
        }
    });

    const CompanyPieChartWidget = RivalIQ.apps.Dashboard.widgets.ChartWidget.extend({
        view: CompanyPie,

        hasFooter: _.constant(true),
        footerView: App.views.WarningLegendFooterView,

        isSupported: function (props) {
            if (!props.metrics || props.metrics.length !== 1) {
                return false;
            }

            if (!_.every(props.metrics, RivalIQ.metric.property.isNumeric)) {
                return false;
            }

            return true;
        },

        propValues: {
            timeAnalysisMode: [
                RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
            ]
        },

        processProps: function (props) {
            const me = this;

            me.metrics = me.buildMetrics(props);

            return _.defaults(props, {
                limit: 15,
                height: RivalIQ.enums.chart.CHART_HEIGHT,
                useUniversalMetricsApi: me.curation.isCustomDashboard
            });
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.COMPANY_PIE_CHART, CompanyPieChartWidget);

    const FocusCompanyPie = CompanyPie.extend({
        getChartAttributes: function () {
            const me = this;
            const attributes = CompanyPie.prototype.getChartAttributes.call(me);

            return _.extend(attributes, {
                concept: me.metric // determines colors of slices
            });
        },

        _getLegendPopoverRow: function (d) {
            const me = this;

            const companyId = me.getProp('companyId');

            let source;
            if (_.includes(me.metric.getFreeDimensions(), ['channel'])) {
                const channelIdx = _.indexOf(me.metric.getFreeDimensions(), 'channel');
                source = RivalIQ.data.channels.get(d[channelIdx]).get('source');
            } else {
                source = me.metric.getSource();
            }

            const calculationMetadata = me.metric.getCalculationMetadata(companyId);
            if (_.includes(_.get(calculationMetadata, ['missingSources']), source) && !_.get(calculationMetadata, ['missingAllSources'])) {
                // Show a warning if we're missing some, but not all, sources.
                return RivalIQ.utils.incompleteData.getIncompleteDataPopover('companyId', companyId, me.metric, calculationMetadata);
            }
        }
    });

    const FocusCompanyPieChartWidget = CompanyPieChartWidget.extend({

        view: FocusCompanyPie,

        footerView: App.views.WarningLegendFooterView.extend({
            loadData: function () {
                const me = this;

                let collection = me.dashboardModel.metricsCollection;
                if (!collection) {
                    collection = new RivalIQ.collections.MetricDefinitions(me.dashboardModel.metrics);
                }

                return collection.fetch()
                    .then(results => {

                        const hasPartialDataWarning = results.any(metric => {
                            if (metric.get('timeAnalysisMode') === RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD) {
                                const calculationMetadata = metric.getCalculationMetadata(me.getProp('companyId'));
                                return !_.isEmpty(_.get(calculationMetadata, ['missingSources'])) && !_.get(calculationMetadata, ['missingAllSources']);
                            }
                        });

                        me.showIncompleteDataWarning = _.constant(hasPartialDataWarning);
                    });
            }
        }),

        isSupported: function (props) {
            const me = this;

            if (!CompanyPieChartWidget.prototype.isSupported.call(me, props)) {
                return false;
            }

            const metric = props.metrics[0];

            // only support metrics that have submetrics
            // NOTE timeAnalysisMode is not a supported free dimension
            return RivalIQ.metric.getFreeDimensions(metric).length === 2 &&
                !_.isUndefined(metric.timeAnalysisMode);
        },

        csvExportProps: function () {
            const me = this;
            const props = CompanyPieChartWidget.prototype.csvExportProps.call(me);

            // HACK remove companyId so we have a free dimension, but set the
            // company set so we only get the focus company
            props.metric[0].companyId = undefined;
            // TODO clean up use of tag here
            props.metric[0].tag = RivalIQ.state.companySets.focus;

            return props;
        },

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                companyId: props.focusCompanyId,
                limit: 15,
                height: RivalIQ.enums.chart.CHART_HEIGHT,
                focusCompanyTitlePlacement: RivalIQ.enums.widgetFocusCompanyTitlePlacement.PREFIX,
                useUniversalMetricsApi: me.curation.isCustomDashboard
            });

            me.metrics = me.buildMetrics(props);

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FOCUS_COMPANY_PIE_CHART, FocusCompanyPieChartWidget);
}, window.d3);
